import { useEffect, useState } from "react";
import { toast } from "sonner";
import { MailCheck, Send } from "lucide-react";
import { http, formatApiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";

const inp = "w-full border border-slate-300 rounded-md px-3 py-2 text-sm";
const msg = (r) => (r?.sent ? "envoyé" : `échec : ${r?.reason || "configuration e-mail"}`);

export const MailTestCard = ({ onSent }) => {
  const { user } = useAuth();
  const [to, setTo] = useState(user?.email || "");
  const [cid, setCid] = useState("");
  const [companies, setCompanies] = useState([]);
  const [busy, setBusy] = useState(false);
  useEffect(() => { http.get("/superadmin/companies").then((r) => setCompanies(r.data.filter((c) => c.status !== "deleted"))).catch(() => {}); }, []);
  const send = async () => {
    setBusy(true);
    try {
      const { data } = await http.post("/superadmin/mail-test", { to, company_id: cid || null });
      const parts = [`Version XALTIX ${msg(data.xaltix)}`];
      if (data.company) parts.push(`version entreprise ${msg(data.company)}${data.company.sent && !data.company.logo ? " (sans logo : aucun logo dans ses paramètres)" : ""}`);
      (data.xaltix?.sent && (!data.company || data.company.sent) ? toast.success : toast.error)(parts.join(" · "));
    } catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); onSent?.(); }
  };
  return (
    <section className="bg-white border border-slate-200 rounded-md p-6" data-testid="mail-test-card">
      <h2 className="font-display font-bold text-xl mb-1 flex items-center gap-2"><MailCheck className="h-5 w-5 text-[#C9962E]" />E-mail d'essai</h2>
      <p className="text-xs text-slate-500 mb-4">Recevez un exemple avec l'habillage XALTIX et, si vous choisissez une entreprise, un second avec son nom et son logo.</p>
      <div className="grid sm:grid-cols-[1fr_1fr_auto] gap-3 items-end">
        <label className="block"><span className="text-[11px] text-slate-500">Adresse de réception</span><input type="email" className={inp} value={to} onChange={(e) => setTo(e.target.value)} data-testid="mail-test-to" /></label>
        <label className="block"><span className="text-[11px] text-slate-500">Version entreprise cliente</span>
          <select className={inp} value={cid} onChange={(e) => setCid(e.target.value)} data-testid="mail-test-company">
            <option value="">— Aucune (XALTIX seulement) —</option>{companies.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
          </select></label>
        <button type="button" onClick={send} disabled={busy || !to.includes("@")} className="inline-flex items-center gap-2 px-4 py-2 rounded-md bg-slate-900 text-white text-sm font-semibold disabled:opacity-50" data-testid="mail-test-send"><Send className="h-4 w-4" />{busy ? "Envoi…" : "Envoyer l'essai"}</button>
      </div>
    </section>
  );
};
